module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYTUwYmNhYWEyZDdkMWM0NzA2YmQxMTgzNTk1Mjg1MzQucG5nIjs="